import ViewBase from "../../../framework/core/mvvm/view_base";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ClubGameSettingView extends ViewBase {

    @property(cc.Sprite)
    gameIcon : cc.Sprite = null;

    @property(cc.Label)
    gameName : cc.Label = null;

    @property(cc.EditBox)
    betNumEditorBox : cc.EditBox = null;
  
    @property(cc.Button)
    deleteButton : cc.Button = null;

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {

    }

    // update (dt) {}
}
